<div class="main-container">
    @if (error$ | async; as error) {
    <p
        class="title"
        style="color: #fff"
        i18n
    >
        {{ ReadableSsoError[error.errorCode] }}
    </p>
    <p
        class="accent-text"
        style="color: #fff"
        i18n
    >
        {{ error.message }}
    </p>
    }
    <button
        (click)="backHandler()"
        class="big-button go-back-button"
        color="primary"
        i18n
        mat-flat-button
    >
        GO BACK
    </button>
</div>
